import { render, staticRenderFns } from "./AdicionarEscola.vue?vue&type=template&id=1b227bb0&scoped=true&"
import script from "./AdicionarEscola.vue?vue&type=script&lang=js&"
export * from "./AdicionarEscola.vue?vue&type=script&lang=js&"
import style0 from "./AdicionarEscola.vue?vue&type=style&index=0&id=1b227bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b227bb0",
  null
  
)

export default component.exports